"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || (function () {
    var ownKeys = function(o) {
        ownKeys = Object.getOwnPropertyNames || function (o) {
            var ar = [];
            for (var k in o) if (Object.prototype.hasOwnProperty.call(o, k)) ar[ar.length] = k;
            return ar;
        };
        return ownKeys(o);
    };
    return function (mod) {
        if (mod && mod.__esModule) return mod;
        var result = {};
        if (mod != null) for (var k = ownKeys(mod), i = 0; i < k.length; i++) if (k[i] !== "default") __createBinding(result, mod, k[i]);
        __setModuleDefault(result, mod);
        return result;
    };
})();
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.getCurrentCityFromAdress = getCurrentCityFromAdress;
exports.getCurrentCountryFromAdress = getCurrentCountryFromAdress;
exports.getAddressFromReults = getAddressFromReults;
/* eslint-disable @typescript-eslint/no-use-before-define */
const react_1 = __importDefault(require("react"));
const react_places_autocomplete_1 = __importStar(require("react-places-autocomplete"));
function GoogleInput({ value, onChange, className = "form-control form-control-profil-custom", placeholder = "Adresse", countries = [], types = [], }) {
    const [search, setSearch] = react_1.default.useState(value || "");
    react_1.default.useEffect(() => {
        setSearch(value);
    }, [value]);
    const onError = react_1.default.useCallback((status, clearSuggestions) => {
        console.log("Google Maps API returned error with status: ", status);
        clearSuggestions();
    }, []);
    const handlechange = (value) => __awaiter(this, void 0, void 0, function* () {
        setSearch(value);
        onChange({
            latitude: "",
            longitude: "",
            rue: value,
            ville: "",
            country: "",
        });
    });
    return (react_1.default.createElement(react_places_autocomplete_1.default, { value: search || "", onError: onError, onChange: handlechange, onSelect: (address) => __awaiter(this, void 0, void 0, function* () {
            setSearch(address);
            try {
                const res = yield (0, react_places_autocomplete_1.geocodeByAddress)(address);
                const data = getAddressFromReults(res);
                if (data) {
                    onChange(Object.assign(Object.assign({}, data), { rue: address }));
                    return;
                }
            }
            catch (ex) { }
            onChange({
                latitude: "0",
                longitude: "0",
                rue: address,
                ville: "",
                country: "",
            });
        }), 
        // apiOptions={{ language: "fr" }}
        searchOptions: {
            types: types,
            componentRestrictions: {
                country: countries,
            },
        } }, ({ getInputProps, suggestions, getSuggestionItemProps, loading, }) => (react_1.default.createElement("div", null,
        react_1.default.createElement("input", Object.assign({}, getInputProps({
            placeholder: placeholder,
            className: className,
        }))),
        react_1.default.createElement("div", { className: "autocomplete-dropdown-container fixe-autocomplete" },
            loading && react_1.default.createElement("div", null, "Loading..."),
            suggestions.map((suggestion, index) => {
                const style = suggestion.active
                    ? {
                        backgroundColor: "#fafafa",
                        cursor: "pointer",
                    }
                    : {
                        backgroundColor: "#EEE",
                        cursor: "pointer",
                    };
                return (react_1.default.createElement("div", Object.assign({}, getSuggestionItemProps(suggestion, {
                    style: Object.assign(Object.assign({}, style), {
                        padding: 10,
                        marginBottom: 2,
                        fontWeight: "bold",
                        color: "#2c3e50",
                    }),
                }), { key: index }),
                    react_1.default.createElement("span", null, suggestion.description)));
            }))))));
}
exports.default = GoogleInput;
function getCurrentCityFromAdress(results) {
    let res = getAddress(results, ["locality"]);
    if (res === "") {
        res = getAddress(results, ["sublocality"]);
    }
    if (res === "") {
        res = getAddress(results, ["sublocality_level_1"]);
    }
    if (res === "") {
        res = getAddress(results, ["administrative_area_level_2"]);
    }
    if (res === "") {
        res = getAddress(results, ["administrative_area_level_1"]);
    }
    if (res === "") {
        res = getAddress(results, ["country"]);
    }
    return res;
}
function getCurrentCountryFromAdress(results) {
    let res = getAddress(results, ["country"]);
    if (res === "") {
        res = getAddress(results, ["country"]);
    }
    return res;
}
function getAddress(results, criters) {
    for (const { address_components } of results) {
        for (const ad of address_components) {
            let exists = true;
            for (const type of criters) {
                if (!ad.types.includes(type))
                    exists = false;
            }
            if (exists === true) {
                return ad.long_name;
            }
        }
    }
    return "";
}
function getAddressFromReults(results) {
    let res = getAd(results, ["street_address"]);
    if (res === null) {
        res = getAd(results, ["route"]);
    }
    if (res === null) {
        res = getAd(results, ["neighborhood", "political"]);
    }
    if (res === null) {
        res = getAd(results, ["sublocality_level_1"]);
    }
    if (res === null) {
        res = getAd(results, ["country"]);
    }
    return res;
}
function getAd(results, criters) {
    var _a, _b, _c, _d;
    for (const result of results) {
        const { address_components } = result;
        let exists = false;
        for (let ad of address_components) {
            for (const type of criters) {
                if (ad.types.includes(type))
                    exists = true;
            }
        }
        if (exists) {
            return {
                rue: String(result === null || result === void 0 ? void 0 : result.formatted_address),
                latitude: String((_b = (_a = result === null || result === void 0 ? void 0 : result.geometry) === null || _a === void 0 ? void 0 : _a.location) === null || _b === void 0 ? void 0 : _b.lat()),
                longitude: String((_d = (_c = result === null || result === void 0 ? void 0 : result.geometry) === null || _c === void 0 ? void 0 : _c.location) === null || _d === void 0 ? void 0 : _d.lng()),
                ville: getCurrentCityFromAdress(results),
                country: getCurrentCountryFromAdress(results),
            };
        }
    }
    return null;
}
